import { useContext } from "react";
import { motion } from "framer-motion";
import { LanguageContext } from "../../../context/LanguageContext";

export default function HowItWorks() {
  const { t, isRTL } = useContext(LanguageContext);
  const steps = t("howItWorks.steps", { returnObjects: true }) || [];

  return (
    <section
      dir={isRTL ? "rtl" : "ltr"}
      className="bg-indigo-50 py-24"
    >
      <div className="mx-auto max-w-7xl px-6">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="text-4xl font-extrabold text-black">
            {t("howItWorks.title")}
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            {t("howItWorks.subtitle")}
          </p>
        </motion.div>

        {/* Steps */}
        <div className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-5">
          {steps.map((step, index) => (
            <motion.div
              key={step.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -6 }}
              className="rounded-2xl bg-white p-6 shadow-sm hover:shadow-md transition"
            >
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-indigo-600 text-white font-bold">
                {step.id}
              </div>

              <h3 className="text-lg font-semibold text-black">
                {step.title}
              </h3>

              <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}
